import type { ImageAttachment } from "@bash/shared";
import type { PendingAttachment } from "./AttachmentHandler";

/**
 * Composer attachments → wire images. Carries the display filename so the
 * server stores the friendly name ("Pasted image <date> at <time>", or the
 * picked file's real name) instead of its `inline-<timestamp>` fallback mint.
 */
export function toWireImages(
  attachments: PendingAttachment[]
): ImageAttachment[] {
  const images: ImageAttachment[] = [];
  for (const a of attachments) {
    if (a.isImage && a.imageData) {
      images.push({
        data: a.imageData.data,
        mediaType: a.imageData.mediaType,
        filename: a.filename,
      });
    }
  }
  return images;
}
